import { getAppRoutes } from '@/constants/routes';
import EmbedBlocked from '@/features/booking-widget/components/EmbedBlocked';
import { getContainmentPolicy } from '@/helpers/containmentPolicy';
import { isSentry } from '@/helpers';
import useMobileView from '@/hooks/useMobileView';
import * as Sentry from '@sentry/react';
import { useEffect, useState } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';

// Custom Route if sentry exists
const AppRoute = isSentry ? Sentry.withSentryRouting(Route) : Route;

const AppRoutes = ({ redirect = null }: { redirect?: JSX.Element }) => {
  const { isMobileView } = useMobileView();
  const location = useLocation();
  const [appRoutes, setAppRoutes] = useState(getAppRoutes(isMobileView));

  useEffect(() => {
    setAppRoutes(getAppRoutes(isMobileView));
  }, [isMobileView]);

  if (redirect) return <Redirect to={redirect} />;

  // A contained flow blocks any route outside its allow-list.
  if (!getContainmentPolicy().allowsRoute(location.pathname)) {
    return <EmbedBlocked />;
  }

  return (
    <Switch>
      {appRoutes.map(({ mountKey, ...route }, i) => (
        <AppRoute {...route} key={mountKey ?? i} />
      ))}
    </Switch>
  );
};
export default AppRoutes;
